import React from "react";
// import Modal from '../Modal'
import LoaderButton from "../components/LoaderButton";
import { checkTranslation, translate } from "../utils/useful";
// import FormViewer from "../FormViewer";
import SwitchInput from "../components/inputs/SwitchInput";
// import TopicView from "../views/messenger/sideBar/TopicView";
// import StagesManager from "../StagesManager";
// import TableViewer from "../TableViewer";
// import FixedView from "../FixedView";
// import Responsive from "../Responsive";
import SelectInput from "../components/inputs/SelectInput";
// import CheckboxInput from "../inputs/CheckboxInput";
// import ButtonAnimated from "../buttons/ButtonAnimated";
import HttpServices from "../utils/Http.services";
import { nanoid } from "nanoid";


class   ImportModalForth extends React.Component {
    state = {
        // yonnect: [
        //     { name: "{{lang}}Name", icon: "/assets/icons/uploadmodal/character.svg" },
        //     { name: "{{lang}}Notes", icon: "/assets/icons/uploadmodal/text.redaction.svg" },
        //     { name: "{{lang}}Assignee", icon: "/assets/icons/uploadmodal/person.svg" },
        //     { name: "{{lang}}Status", icon: "/assets/icons/uploadmodal/bolt.circle.svg" },
        // ],

        // arrow: [
        //     { icon: "/assets/icons/uploadmodal/arrow.left.svg" },
        //     { icon: "/assets/icons/uploadmodal/arrow.left.svg" },
        //     { icon: "/assets/icons/uploadmodal/arrow.left.svg" },
        //     { icon: "/assets/icons/uploadmodal/arrow.left.svg" },
        // ],

        // headers: [
        //     { key: 'papersize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: '{{lang}}Less Than', value: 'Equal' }], label: '{{lang}}Paper Size', placeholder: 'A4 (210mm x 297mm)', required: true } },
        //     { key: 'papersize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: '{{lang}}Less Than', value: 'Equal' }], label: '{{lang}}Paper Size', placeholder: 'A4 (210mm x 297mm)', required: true } },
        //     { key: 'papersize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: '{{lang}}Less Than', value: 'Equal' }], label: '{{lang}}Paper Size', placeholder: 'A4 (210mm x 297mm)', required: true } },
        //     { key: 'papersize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: '{{lang}}Less Than', value: 'Equal' }], label: '{{lang}}Paper Size', placeholder: 'A4 (210mm x 297mm)', required: true } },
        // ],

        headersxs: [
            { key: 'papersize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: '{{lang}}Less Than', value: 'Equal' }], label: '{{lang}}Paper Size', placeholder: 'A4 (210mm x 297mm)', required: true } },
            // { key: 'papersize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Paper Size', placeholder: 'A4 (210mm x 297mm)', required: true } },
            // { key: 'papersize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Paper Size', placeholder: 'A4 (210mm x 297mm)', required: true } },
            // { key: 'papersize', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'A4 (210mm x 297mm)', value: 'Equal' }, { title: 'Less Than', value: 'Equal' }], label: '{{lang}}Paper Size', placeholder: 'A4 (210mm x 297mm)', required: true } },
        ],



    }

    changeField = (key, value, extra) => {
        let fields = this.props.importInfo?.fields
        fields[key] = value
        this.props.changeImportInfo("fields", fields)
    }

    changeSettings = (key, value) => {
        let settings = this.props.importInfo?.settings
        settings[key] = value
        this.props.changeImportInfo("settings", settings)
    }

    submitImport = () => {

        let tempId = nanoid()
        let file = this.props.importInfo?.file

        if (file) {
            this.setState({ isLoadingPost: true })
            HttpServices.addUploadQueque(file, { folder: this.props.applet?._id, type: 'upload', drive: '123', applet: this.props.applet }, tempId, (fetchResult, fetchError) => {
                console.log(fetchResult)
                if (fetchResult) {

                    let body = { ...this.props.importInfo }
                    body.file = fetchResult
                    body.applet = this.props.page?.applet
                    body.frame = this.props.page?._id
                    body.type = 'record'


                    HttpServices.request('submitImport', body, ((fetchResult, fetchError) => {

                        this.setState({ isLoadingPost: false })


                    }))

                } else {
                    this.setState({ isLoadingPost: false })
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.somethingWentWrong', description: '{{lang}}errors.checkYourInternetConnection' })

                }

            })
        }

    }


    render() {
        return (


            <div className="h-100 br-10 sc-gray2 mx-2" style={{ backgroundColor: "white", overflowY: "scroll" }}>
                <div className="">


                    <div className="d-flex flex-wrap p-4">



                        <div className="mb-3 d-flex justify-content-between w-100"  >
                            <div>
                                <p className="font-size-20 weight-500" style={{ color: "#444" }}>{translate('Map Fields Untitled Base — Table 1')}</p>
                                <p className="font-size-12 eight-300 mt-1" style={{ color: "#666" }}>{translate("Here's the data you're importing—check to make sure it's right or let us know if something looks wrong")}.</p>
                            </div>
                            {/* <ButtonAnimated
                                iconwidth='24px'
                                onClick={this.submitImport}
                                title='submit'
                                icon='/assets/icons/plus-white.svg'
                                textColor={this.props.colors?.textColor}
                                invert={this.props.colors?.iconInvert}
                                bg={this.props.colors?.background}
                                isLoading={this.state.isLoadingPost}
                            /> */}
                            <LoaderButton
                                onClick={this.submitImport}
                                isLoading={this.state.isLoading}
                                text={translate("unsubscribe")}
                                type={"Oval"}
                                className="mt-3"
                                buttonStyle={{ outline: 'none', backgroundImage: 'linear-gradient(to right bottom,#ee5050,#dd2020)', cursor: 'pointer', padding: '10px 50px', borderRadius: 40, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                                width={40}
                                height={40}
                                color={'#00A7DA'}
                            />
                        </div>


                        <div className="w-100">

                            <div className="p-2 py-3 br-6 mb-3 flexc" style={{ backgroundColor: '#f6f6f6' }}>
                                <SwitchInput data={this.props.importInfo?.settings['excludeFirstRow']} header={{ key: 'excludeFirstRow', information: {} }} changeValue={this.changeSettings} />
                                <p className="text-small px-2">{translate("Exclude first row in import")}</p>
                            </div>



                            <div className={"flexcb w-100"}>
                                <div className="flex-1">
                                    <p className="text-small text-semibold">{translate('Yonnect Fields')}</p>
                                </div>
                                <div>

                                </div>
                                <div className="flex-1">
                                    <p className="mld-5 text-small text-semibold">{translate('Import Fields')}</p>
                                </div>
                            </div>
                            <div style={{ marginTop: "20px" }}>
                                {this.props.headers?.map((prop, index) => {
                                    return (
                                        <div className="flexcb mb-4">



                                            <div className="flexc flex-1" >

                                                <SwitchInput data={this.props.importInfo?.fields[prop.key]} header={{ key: prop.key, information: {} }} changeValue={() => this.changeField(prop.key, null)} />

                                                <div className="flexc">
                                                    <div className="br-4 mx-1 px-1" style={{ backgroundColor: '#f0f0f0' }}>
                                                        {/* <img className="flexcc" style={{ filter: 'grayscale(100%)' }} src={fieldTypeToIcon(prop.type)} width={20} /> */}
                                                    </div>
                                                    <p className="text-small">{checkTranslation(prop?.information?.label)}</p>
                                                </div>
                                            </div>

                                            <div className="flexc px-2" style={{}}>
                                                <img width={14} src={'/assets/icons/arrow-right.svg'} />
                                            </div>



                                            <div className="flex-1">
                                                <div className="br-4 px-2 py-1 " style={{ border: '1px solid #ddd' }}>
                                                    <SelectInput data={this.props.importInfo?.fields[prop.key]} header={{ key: prop.key, information: { items: this.props.importInfo?.rawHeaders } }} changeValue={this.changeField} />
                                                </div>
                                            </div>

                                            {/* <div className={"mt-3" + conditionalWidth(this.props.width, { xs: ' d-block ', sm: ' d-none ' })}>
                                                    <img style={{ rotate: "270deg" }} src="/assets/icons/uploadmodal/arrow.left.svg" />
                                                    <FormViewer ref={el => this.form = el} headers={this.state.headersxs} theme={"modern"} inputClass={"modern-input"} />
                                                </div> */}


                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        {/* <Responsive width={this.props.width} display={'flex'} media={{ xs: 'none', sm: '1', md: '1' }}>
                            <div style={{ marginTop: "58px" }}>
                                {this.state.arrow.map((prop, index) => {
                                    return (
                                        <div className="flexc" style={{ marginBottom: "48px" }}>
                                            <img src={prop.icon} />
                                        </div>
                                    )
                                })}
                            </div>
                        </Responsive>
                        <Responsive width={this.props.width} display={'flex'} media={{ xs: 'none', sm: '8', md: '8' }}>
                            <div>
                                <p className="mld-5">{translate('Import Fields')}</p>
                                <div className="mt-2">
                                    <FormViewer ref={el => this.form = el} headers={this.state.headers} theme={"modern"} inputClass={"modern-input"} />
                                </div>
                            </div>
                        </Responsive> */}
                    </div>
                </div>
            </div>

        );

    }
}


export default ImportModalForth;


// const mapStateToProps = state => ({  queque: state.queque })
// const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps,
//     null,
//     { forwardRef: true }
// )(ImportModalForth);